import React, { useState, useEffect } from "react";
import { X, UserPlus, Edit3,ChevronDown  } from "lucide-react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";

const Users = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [departments, setDepartments] = useState([]);

  // حالة نموذج الإضافة (مطابقة لـ SQL Server Controller)
  const [formData, setFormData] = useState({
    fileNumber: "",
    name: "",
    birthDate: "",
    financialGrade: "",
    groupType: "",
    jobTitle: "",
    planCapacity: "",
    notes: "",
  });

  useEffect(() => {
    document.title = "موظفين - الإدارة العامة للعمليات والتوقيع الإلكتروني";
    fetchEmployees();
  }, []);

  // دالة جلب الموظفين
  const fetchEmployees = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch("/api/employees", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("فشل في جلب البيانات");

      const data = await response.json();
      setEmployees(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await fetch("/api/departments", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await response.json();
      setDepartments(data); // حفظ البيانات في الـ state
    } catch (error) {
      console.error("خطأ في جلب الإدارات:", error);
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchDepartments(); // إضافة دالة لجلب الإدارات
  }, []);

  // دالة تحديث المدخلات ديناميكياً
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleEdit = (emp) => {
    setEditingId(emp.id); // هنا نضع الـ ID الحقيقي للموظف ليتم التعديل عليه
    setFormData({
      fileNumber: emp.fileNumber || "",
      name: emp.name || "",
      birthDate: emp.birthDate ? emp.birthDate.split("T")[0] : "",
      financialGrade: emp.financialGrade || "",
      groupType: emp.groupType || "",
      jobTitle: emp.jobTitle || "",
      planCapacity: emp.planCapacity || "",
      notes: emp.notes || "",
      departmentId: emp.departmentId || "", // لا تفرغ هذا، بل ضع قيمة الموظف الحالية
    });
    setIsModalOpen(true);
  };

  // دالة حفظ الموظف الجديد
  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = editingId
      ? `/api/employees/${editingId}`
      : "/api/employees";

    const method = editingId ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        // تأكد أن القيم الفارغة تُرسل كـ null للسيرفر بدلاً من نص فارغ
        body: JSON.stringify({
          ...formData,
          departmentId:
            formData.departmentId === "" ? null : formData.departmentId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "حدث خطأ أثناء حفظ البيانات");
      }

      // إذا نجح الطلب:
      setIsModalOpen(false);
      setEditingId(null);
      setFormData({
        fileNumber: "",
        name: "",
        birthDate: "",
        financialGrade: "",
        groupType: "",
        jobTitle: "",
        planCapacity: "",
        notes: "",
        departmentId: "",
      });

      // تحديث الجدول
      fetchEmployees();
      alert("تم حفظ البيانات بنجاح");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
    }
  };

  // دالة مساعدة لتنسيق التاريخ لإزالة وقت الزون T00:00:00.000Z
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dateString.split("T")[0]; // تأخذ الجزء الممتد قبل حرف T مباشرة
  };

  return (
    <div className="flex min-h-screen bg-[#F8F9FA] font-ibm" dir="rtl">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
      />

      <div
        className={`flex-1 transition-all duration-300 p-4 md:p-8 overflow-y-auto ${isSidebarOpen ? "lg:mr-64" : "lg:mr-20"}`}
      >
        <Header
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          title="الموظفين"
        />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6 text-right">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#546E7A]">
              الموظفين
            </h2>
            <p className="text-gray-400 mt-1">إدارة صلاحيات الموظفين</p>
          </div>
          <button
            onClick={() => {
              // 1. تصفير الـ id ليعرف المودال أننا في وضع "إضافة"
              setEditingId(null);

              // 2. تصفير البيانات لتظهر الحقول فارغة
              setFormData({
                fileNumber: "",
                name: "",
                birthDate: "",
                financialGrade: "",
                groupType: "",
                jobTitle: "",
                planCapacity: "",
                notes: "",
                departmentId: "",
              });

              // 3. فتح المودال
              setIsModalOpen(true);
            }}
            className="bg-[#546E7A] hover:bg-[#263238] text-white font-ibm px-8 py-3 rounded-2xl font-bold flex items-center gap-2 transition shadow-lg shadow-[#546e7a20] w-full md:w-auto justify-center active:scale-95"
          >
            <UserPlus size={20} /> موظف جديد
          </button>
        </div>

        {/* عرض جدول الموظفين */}
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-50 overflow-hidden">
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-right">
              <thead>
                <tr className="bg-[#F8F9FA] text-[#546E7A] border-b border-gray-50">
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    #
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    رقم الحاسب/ الملف
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    اسم الموظف
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    تاريخ الميلاد
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الدرجه المالية
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    المجموعة النوعية
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الوظيفة
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الإدارة
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-center whitespace-nowrap">
                    نسبة المشاركه فى الأدارة
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-center whitespace-nowrap">
                    ملاحظات
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-center whitespace-nowrap">
                    إجراءات
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {employees.map((emp) => (
                  <tr
                    key={emp.id}
                    className="hover:bg-gray-50/50 transition-colors"
                  >
                    <td className="px-6 py-4 text-sm font-bold text-[#263238] whitespace-nowrap">
                      {emp.id}
                    </td>
                    <td className="px-6 py-4 text-sm font-bold text-[#263238] whitespace-nowrap">
                      {emp.fileNumber}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                      {emp.name}
                    </td>
                    {/* هنا تم إصلاح وعرض التاريخ النظيف فقط */}
                    <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                      {formatDate(emp.birthDate)}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {emp.financialGrade}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {emp.groupType}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {emp.jobTitle}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {emp.departmentName}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 text-center whitespace-nowrap">
                      {emp.planCapacity}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 text-center whitespace-nowrap">
                      {emp.notes}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 text-center whitespace-nowrap">
                      <button
                        onClick={() => handleEdit(emp)}
                        className=" text-gray-400 py-2 px-4 rounded-md"
                      >
                        <Edit3 size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* العرض على الهواتف الذكية (Mobile Cards) */}
          <div className="md:hidden divide-y divide-gray-50">
            {employees.map((emp) => (
              <div
                key={emp.id}
                className="p-4 hover:bg-gray-50/50 transition-colors text-right"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="font-bold text-[#263238] text-sm">
                    {emp.name}
                  </span>
                  <span className="text-xs text-gray-400">
                    ملف: {emp.fileNumber}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2 mb-3 text-xs">
                  <div>
                    <span className="text-gray-400">تاريخ الميلاد</span>
                    <p className="text-gray-600 font-medium">
                      {formatDate(emp.birthDate)}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-400">الوظيفة</span>
                    <p className="text-gray-600 font-medium">{emp.jobTitle}</p>
                  </div>
                  <div>
                    <span className="text-gray-400">الدرجة المالية</span>
                    <p className="text-gray-500">{emp.financialGrade}</p>
                  </div>
                  <div>
                    <span className="text-gray-400">المجموعة النوعية</span>
                    <p className="text-[#546E7A] font-medium">
                      {emp.groupType}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* مودال إضافة موظف جديد (نفس تصميم الـ UI الأصلي والجميل الخاص بك) */}
        {isModalOpen && (
          <div className="fixed inset-0 z-[200] overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <div
                className="fixed inset-0 bg-[#263238]/60 backdrop-blur-sm"
                onClick={() => setIsModalOpen(false)}
              ></div>
              <div
                className="relative bg-white w-full max-w-2xl rounded-[2.5rem] shadow-2xl overflow-hidden text-right"
                dir="rtl"
              >
                {/* Header */}
                <div className="p-8 bg-white flex justify-between items-center">
                  <h3 className="text-xl font-bold text-[#263238]">
                    {editingId ? "تعديل بيانات الموظف" : "إضافة موظف جديد"}
                  </h3>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="p-2 hover:bg-gray-200 rounded-full transition-colors"
                  >
                    <X size={24} className="text-gray-400" />
                  </button>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* رقم الملف */}
                    <div className="relative">
                      <input
                        type="number"
                        id="fileNumber"
                        value={formData.fileNumber}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="fileNumber"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        رقم الحاسب/ الملف
                      </label>
                    </div>
                    {/* الاسم */}
                    <div className="relative">
                      <input
                        type="text"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="name"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        اسم الموظف
                      </label>
                    </div>
                    {/* تاريخ الميلاد */}
                    <div className="relative">
                      <input
                        type="date"
                        id="birthDate"
                        value={formData.birthDate}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="birthDate"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        تاريخ الميلاد
                      </label>
                    </div>
                    {/* الدرجة المالية */}
                    <div className="relative">
                      <input
                        type="text"
                        id="financialGrade"
                        value={formData.financialGrade}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="financialGrade"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        الدرجة المالية
                      </label>
                    </div>
                    {/* المجموعة النوعية */}
                    <div className="relative">
                      <input
                        type="text"
                        id="groupType"
                        value={formData.groupType}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="groupType"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        المجموعة النوعية
                      </label>
                    </div>
                    {/* الوظيفة */}
                    <div className="relative">
                      <input
                        type="text"
                        id="jobTitle"
                        value={formData.jobTitle}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="jobTitle"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        الوظيفة
                      </label>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* الإدارة */}
                    <div className="relative">
                      <select
                        id="departmentId"
                        value={formData.departmentId || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            departmentId: e.target.value,
                          })
                        }
                        className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer"
                      >
                        <option value="" disabled hidden></option>
                        {departments.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.name}
                          </option>
                        ))}
                      </select>
                     <label
                      className="absolute text-sm font-bold text-gray-500 duration-300 transform z-10 origin-[right] right-4 pointer-events-none movementType top-4 translate-y-0 scale-100 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A]"
                    >
                      الإدارة
                    </label>
                       <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                    </div>
                    {/* الطاقة الفعلية */}
                    <div className="relative">
                      <input
                        type="number"
                        id="planCapacity"
                        value={formData.planCapacity}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="planCapacity"
                        className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        الطاقة الفعلية للمشاركة فى الخطة
                      </label>
                    </div>
                  </div>

                  {/* ملاحظات */}
                  <div className="relative">
                    <textarea
                      id="notes"
                      value={formData.notes || ""}
                      onChange={handleChange}
                      placeholder=" "
                      rows="3"
                      className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right resize-none"
                    />
                    <label
                      htmlFor="notes"
                      className="absolute text-sm font-bold text-gray-500 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                    >
                      ملاحظات
                    </label>
                  </div>

                  {/* Buttons */}
                  <div className="flex gap-4 pt-4">
                    <button
                      type="submit"
                      className="flex-[2] bg-[#546E7A] hover:bg-[#263238] text-white py-4 rounded-2xl font-bold transition-all shadow-xl shadow-[#546e7a30] active:scale-[0.98]"
                    >
                      {editingId ? "حفظ التعديلات" : "إضافة موظف "}
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 py-4 rounded-2xl font-bold transition-all active:scale-[0.98]"
                    >
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;
